import FlexPane from './_flex-pane.js'
import FiltersBar from './_filters-bar.js'

export default {
  name: 'MatchesView',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '8px 0 0 0',
          _mobile_padding: '8px',
        },
      },
    },
    contentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    filterContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
        },
      },
    },
    filtersBar: {
      configSet: FiltersBar,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
